
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1od01_103",
  "disabled": "awsui_disabled_8cbea_1od01_183",
  "selected": "awsui_selected_8cbea_1od01_191",
  "icon": "awsui_icon_8cbea_1od01_212",
  "with-text": "awsui_with-text_8cbea_1od01_216",
  "with-no-text": "awsui_with-no-text_8cbea_1od01_222",
  "root": "awsui_root_8cbea_1od01_231",
  "segment-part": "awsui_segment-part_8cbea_1od01_266",
  "select": "awsui_select_8cbea_1od01_191",
  "segment-count-2": "awsui_segment-count-2_8cbea_1od01_285",
  "segment-count-3": "awsui_segment-count-3_8cbea_1od01_290",
  "segment-count-4": "awsui_segment-count-4_8cbea_1od01_295",
  "segment-count-5": "awsui_segment-count-5_8cbea_1od01_300",
  "segment-count-6": "awsui_segment-count-6_8cbea_1od01_305"
};
  